<template>
  <div class="promotionLink">
    <div class="promotionLink_titleArea">
      <h3 class="title">推广链接</h3>
      <i class="icon" @click="$emit('close')">x</i>
    </div>
    <div class="promotionLink_mainArea">
      <p class="tips">以下是该落地页的推广链接，你可以在创建时在落地页的“自定义”填充该链接</p>
      <span class="mainTitle">{{ activeItem.publish_url }}</span>
    </div>
    <div class="promotionLink_buttonArea">
      <el-button class="copy-btn" type="primary" data-clipboard-action="copy" data-clipboard-target=".mainTitle" @click="copy">复制链接</el-button>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
export default {
  props: {
    activeItem: {}
  },
  data() {
    return {

    }
  },
  methods: {
    copy() {
      if (!this.activeItem) return
      const clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        this.$message({
          message: '复制链接成功',
          type: 'success'
        })
        clipboard.destroy()
        this.$emit('close', 'copyLink')
      })
      clipboard.on('error', e => {
        clipboard.destroy()
      })
    }
  }
}
</script>

<style scoped lang="less">
.promotionLink{
  width: 500px;
  height: 300px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  .promotionLink_titleArea{
    padding: 20px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    .title{
      font-weight: bold;

    }
    .icon{
      font-style: normal;
      font-size: 17px;
      cursor: pointer;
      &:hover{
        font-weight: bold;
      }
    }
  }

  .promotionLink_mainArea{
    padding: 20px;
    flex-grow: 1;
     .tips{
      color: #a5a2a2;
     }
     .mainTitle{
      display: inline-block;
      margin-top: 5px;
      font-weight: bold;
     }
  }

  .promotionLink_buttonArea{
    padding: 20px;
    border-top: 1px solid #ccc;
    display: flex;
    justify-content: flex-end;

  }
}
</style>
